import React from 'react';
import { UploadedFile } from '../../../../../../../common/domain/upload';
import TextAlert from '../../../TextAlert';
import { GameLoaderType, UNITY_GAME_LOADERS } from '@crazygames/game-types/src/game-build/loader.type';

export interface UnityCompressionWarningsProps {
  gameLoaderType: GameLoaderType | null;
  files: UploadedFile[] | null;
}

const UnityCompressionWarnings: React.FC<UnityCompressionWarningsProps> = (props) => {
  const { gameLoaderType, files } = props;

  if (!gameLoaderType || !UNITY_GAME_LOADERS.includes(gameLoaderType)) {
    return null;
  }

  const showBrotliWarning = files && files.length > 0 && !files.some((f) => f.path.endsWith('.br'));

  return (
    <>
      {showBrotliWarning && (
        <TextAlert>Compression could not be detected automatically, please be sure your files are brotli compressed.</TextAlert>
      )}
    </>
  );
};

export default UnityCompressionWarnings;
